import { UPDATE_MEMBERSHIP, UPDATE_MEMBERSHIP_SUCCESS, UPDATE_MEMBERSHIP_ERROR, UPDATE_MEMBERSHIP_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateMembership = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MEMBERSHIP:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_MEMBERSHIP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_MEMBERSHIP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_MEMBERSHIP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateMembership;
